// 查询媒体  是否是水平放置的手机

import { useDidShow } from '@tarojs/taro';

function useQueryMedia(maxHeight = '960px', maxWidth = '760px') {
    //  手机设备水平放置
    const [isPhoneHorizontal, setIsPhoneHorizontal] = useState(false);
    const [isPhoneVertical, setIsPhoneVertical] = useState(false);
    const queryMediaListener2 = e => {
            setIsPhoneVertical(e.matches);
    };
    
    const queryMediaListener = e => {
        setIsPhoneHorizontal(e.matches);
    };

    let queryMedia = null;
    let queryMedia2 = null;

    const queryMediaData = () => {
         // 横屏判断
        queryMedia = window.matchMedia(
            `(max-width:${maxHeight}) and (min-aspect-ratio: 1/1)`
        );

        // 竖屏判断
        queryMedia2 = window.matchMedia(
            `(max-width:${maxWidth}) and (max-aspect-ratio: 1/1)`
        );
        setIsPhoneHorizontal(queryMedia.matches);
        setIsPhoneVertical(queryMedia2.matches);
    }

    useDidShow(() => {
        queryMediaData();
        console.log('zx useQueryMedia useDidShow: ', queryMedia2.matches, isPhoneVertical, queryMedia.matches,isPhoneHorizontal, window.location.href );
    });

    useEffect(() => { 
        queryMediaData()
        console.log('zx useQueryMedia useEffect: ', queryMedia2.matches, isPhoneVertical, queryMedia.matches,isPhoneHorizontal );

        queryMedia?.addListener(queryMediaListener);
        queryMedia2?.addListener(queryMediaListener2);

        return () => {
            console.log('zx useQueryMedia useEffect return');
            queryMedia?.removeListener(queryMediaListener);
            queryMedia2?.removeListener(queryMediaListener2);
        }
    }, []);

    return [isPhoneHorizontal, isPhoneVertical];
}

export default useQueryMedia;
